module.exports = __webpack_public_path__ + "img/title-img.1cdfe4b3.png";